<div class="card">
  <div class="card-body">
    <!-- Row -->
<div class="row">
  <!-- Column -->
  <div class="col-lg-4 col-md-6 col-sm-6">
      <div class="card card-inverse" style="background-color: seagreen;">
          <div class="card-body">
              <div class="d-flex">
                  <div class="m-r-20 align-self-center">
                      <h1 class="text-white"><i class="ti-home"></i></h1></div>
                  <div>
                    <a routerLink="/inmuebles"><h3 class="card-title">Inmuebles registrados</h3></a>
                      <h1 class="card-subtitle" style="text-align: end;">{{totalInmueblesRegistrados}}</h1> </div>
              </div>
          </div>
      </div>
  </div>
  <!-- Column -->

   <!-- Column -->
   <div class="col-lg-4 col-md-6 col-sm-6">
    <div class="card card-inverse" style="background-color: slategray;">
        <div class="card-body">
            <div class="d-flex">
                <div class="m-r-20 align-self-center">
                    <h1 class="text-white"><i class="ti-alarm-clock"></i></h1></div>
                <div>
                  <a routerLink="/visitas"><h3 class="card-title">Solicitudes de visita pendientes</h3></a>
                    <h1 class="card-subtitle" style="text-align: end;">{{solicitudVisitasPendientes}}</h1> </div>
            </div>
        </div>
    </div>
</div>
<!-- Column -->

 <!-- Column -->
 <div class="col-lg-4 col-md-6 col-sm-6">
  <div class="card card-inverse card-primary">
      <div class="card-body">
          <div class="d-flex">
              <div class="m-r-20 align-self-center">
                  <h1 class="text-white"><i class="ti-agenda"></i></h1></div>
              <div>
                <a routerLink="/vercontrato"><h3 class="card-title">Contratos pendientes</h3></a>
                  <h1 class="card-subtitle" style="text-align: end;">{{totalContratosPendientes}}</h1> </div>
          </div>
      </div>
  </div>
</div>
<!-- Column -->

 <!-- Column -->
 <div class="col-lg-4 col-md-6 col-sm-6">
  <div class="card card-inverse" style="background-color: salmon;">
      <div class="card-body">
          <div class="d-flex">
              <div class="m-r-20 align-self-center">
                  <h1 class="text-white"><i class="ti-thumb-up"></i></h1></div>
              <div>
                <a routerLink="/publicados"><h3 class="card-title">Inmuebles Publicados</h3></a>
                  <h1 class="card-subtitle" style="text-align: end;">{{totalInmueblesPublicadosArrendador}}</h1> </div>
          </div>
      </div>
  </div>
</div>
<!-- Column -->

</div>
<!-- Row -->

  </div>
</div>
